import { SelectAllFilters } from './typings'

export const selectAllFiltersActionCreator = (): SelectAllFilters => ({
  type: 'activityHistoryFilters/selectAll',
})
